"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiRecourtCreditCorporationTrads = void 0;
exports.ESubScpiRecourtCreditCorporationTrads = {
    neSaisPas: "Je ne sais pas",
    non: "Non",
    oui: "Oui",
};
